module.exports = __webpack_public_path__ + "static/img/zysxfkqhxq.3d92be1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/view/microFireHouse/images/prodImgs/zysxfkqhxq.jpg
// module id = S93H
// module chunks = 21